import { Tabs as AntTabs } from 'antd';

export { default as Tabs } from './Tabs';
export const TabPane = AntTabs.TabPane;
